import UploadSection from './UploadSection';
import { FaRegFile } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { showDialog } from '../actions';
import { FileType } from './Lightbox';
import { FaTrash } from 'react-icons/fa';
import { MdDownload } from 'react-icons/md';

export interface MediaFile {
  downloadUrl: string;
  mimeType: string;
  description?: string;
}

interface FilesProps {
  files: any[];
  addFileFunction: (formData: FormData) => any;
  deleteFileFunction: (f: any) => any;
  canAdd?: boolean;
  canDelete?: boolean;
  multipleFiles?: boolean;
  fileTypes?: string[];
}

export const Files = ({
  files,
  addFileFunction,
  deleteFileFunction,
  canAdd = false,
  canDelete = false,
  multipleFiles = false,
  fileTypes = ['image', 'video'],
}: FilesProps) => {
  const dispatch = useDispatch();
  const getFileType = (file: MediaFile) => {
    if (file.mimeType.includes('image')) {
      return FileType.Image;
    } else if (file.mimeType.includes('video')) {
      return FileType.Video;
    } else {
      return FileType.Other;
    }
  };
  const getMediaItem = (file: MediaFile) => {
    const fileType = getFileType(file);
    if (fileType === FileType.Image) {
      return <img className="media-item-photo" src={file.downloadUrl} alt="url" />;
    } else if (fileType === FileType.Video) {
      return <video className="media-item-video" src={file.downloadUrl} controls />;
    } else {
      return (
        <div className="media-item-other">
          <FaRegFile />
        </div>
      );
    }
  };
  const displayLightbox = (file: MediaFile) => {
    // The lightbox can only show images and video; open documents such as PDFs in a new tab.
    if (getFileType(file) === FileType.Other) {
      window.open(file.downloadUrl, '_blank', 'noopener');
      return;
    }
    const dialogProps = {
      isOpen: true,
      mediaFile: file,
      type: getFileType(file),
    };
    dispatch(showDialog('LIGHTBOX', dialogProps));
  };
  return (
    <div className="media-content files-media">
      {canAdd && (
        <UploadSection
          fileType={fileTypes}
          addFile={addFileFunction}
          multipleFiles={multipleFiles}
        />
      )}
      <div className="media media-video">
        {files &&
          files.map((file, index) => (
            <button className="media-item" key={index} onClick={() => displayLightbox(file)}>
              <div className="media-item-container">{getMediaItem(file)}</div>
              <div className="media-item-description">
                <span>{file.description}</span>
                <span className="media-controls">
                  <a
                    href={file.downloadUrl}
                    className="button transparent download"
                    download
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <MdDownload />
                  </a>
                  {canDelete && (
                    <button
                      className="button transparent"
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteFileFunction(file);
                      }}
                    >
                      <FaTrash />
                    </button>
                  )}
                </span>
              </div>
            </button>
          ))}
      </div>
    </div>
  );
};
